import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

export function VoicePage() {
  const navigate = useNavigate()

  useEffect(() => {
    navigate('/accounts', { replace: true })
  }, [navigate])

  return null
}
